import { connect } from 'react-redux';
import withRouter from 'shared/helper/with-router';
import { getCreditBalance } from 'researcher/user/reducer';
import { getDisplayCredits, getExcludedPaymentMethods, getInvoiceNumbers, getPaymentCurrencyMatchesInvoiceCurrency, getPayoffCurrency, getUnpaidInvoiceTotal, getUnpaidInvoiceUsdTotal, getUnpaidInvoices } from '../reducer';
import InvoicePayment from './InvoicePayment';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var payment = _ref.payment,
    invoice = _ref.invoice,
    user = _ref.user;
  var match = _ref2.match;
  return {
    creditBalance: getCreditBalance({
      user: user
    }),
    currency: getPayoffCurrency({
      payment: payment,
      user: user
    }),
    displayCredits: getDisplayCredits({
      payment: payment
    }),
    excludedPaymentMethods: getExcludedPaymentMethods({
      invoice: invoice,
      user: user,
      match: match
    }),
    formData: payment.formData,
    invoiceNumbers: getInvoiceNumbers({
      match: match,
      invoice: invoice
    }),
    paymentCurrencyMatchesInvoiceCurrency: getPaymentCurrencyMatchesInvoiceCurrency({
      user: user,
      payment: payment
    }),
    receiptCode: payment.receiptCodes.payoff,
    status: payment.status,
    total: getUnpaidInvoiceTotal({
      invoice: invoice,
      user: user,
      match: match
    }),
    usdTotal: getUnpaidInvoiceUsdTotal({
      invoice: invoice,
      user: user,
      match: match
    }),
    unpaidInvoices: getUnpaidInvoices({
      invoice: invoice,
      user: user,
      match: match
    })
  };
};
export default withRouter(connect(mapStateToProps)(InvoicePayment));